export default __webpack_public_path__ + "img/base industrielle.b47362ac.jpg";